import { createTheme, ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import dayjs from 'dayjs';
import React, { useState } from 'react';
import Colors from '../../colors';
import { convertTimestampToFormattedString } from '../../utils/helpers';
import ModalContainer from './ModalContainer';

function DateSelector({ isVisible, setIsVisible, dataCallback }) {
  const theme = createTheme({
    palette: {
      primary: {
        main: Colors.black,
      },
    },
    components: {
      MuiDateCalendar: {
        styleOverrides: {
          root: {
            borderRadius: '16px',
            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.15',
          },

        },
      },
    },
  });
  const [selectedDate, setSelectedDate] = useState(null);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    dataCallback(convertTimestampToFormattedString(date));
    setIsVisible(false);
  };

  return (
    <ModalContainer isVisible={isVisible} setIsVisible={setIsVisible} showCloseIcon={false}
      style={{ width: 'auto', paddingBottom: 0 }}>
      <ThemeProvider theme={theme}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DateCalendar value={selectedDate} onChange={handleDateChange}
          />
        </LocalizationProvider>
        {selectedDate && (
          <p>
            You have selected:{' '}
            {dayjs(selectedDate).format('ddd, DD MMMM YYYY')}
          </p>
        )}
      </ThemeProvider>
    </ModalContainer>

  );
}

export default DateSelector;
